<template>
  <div id="yunxiao" :class="{ collapse: collapse }" v-loading="startFlag === 'loading'" element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)">
    <template v-if="startFlag === 'ready'">
      <app-menu :list="list" @collapse="onCollapse" />
      <div class="right-panel">
        <div class="nav-container">
          <app-nav />
        </div>
        <div class="right-area">
          <el-scrollbar class="page-container" @scroll="pageScroll" wrap-class="page-scroll-wrap">
            <el-breadcrumb separator="/" class="bread-crumb" v-if="breadList.length">
              <el-breadcrumb-item v-for="(item, index) in breadList" :key="index">
                {{ item.menuName }}
              </el-breadcrumb-item>
            </el-breadcrumb>
            <div class="page">
              <custom-router />
            </div>
          </el-scrollbar>

          <!-- 帮助中心 -->
        </div>
      </div>
    </template>
    <div class="exception-container" v-if="startFlag === 'server-expired'">
      <div class="server-expired">
        <img :src="LogoTitle" class="logo-container" />
        <div class="center-info">
          <div class="company-name">{{ companyInfo.companyName }}</div>
          <div class="desc">
            {{ companyInfo.productStatus == 2 ? '抱歉，该学校的服务已到期' : '抱歉，该学校的试用体验已到期' }}
          </div>
          <div class="desc">
            {{
              companyInfo.productStatus == 2
              ? '微信扫码关注公众号，续费可恢复服务'
              : '微信扫码关注公众号，开通可恢复服务'
            }}
          </div>
          <img class="qr-code" :src="qrcode" />
          <div>
            <el-button type="default" class="btn" @click="logout">退出</el-button>
            <el-button type="primary" class="btn" @click="changeCompany"
              v-if="companyInfo.companyList.length > 1">切换学校</el-button>
          </div>
        </div>

        <div class="about">
          <div class="about-1">校管家提供技术支持</div>
          <div class="about-2">
            Copyright © 2015-2021 深圳市智汇管家数字科技有限公司 All Rights Reserved. 粤ICP备12072326号
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogoTitle from '@teacher/assets/images/yx-title-2.png';
import qrcode from '@teacher/assets/images/xiaogj_yunxiao_weixin.jpg';
import {
  ref, watch, inject, reactive,
} from 'vue';
import { updatePosition } from '@teacher/router/index';
import { useRoute, useRouter } from 'vue-router';
import events from '@teacher/config/event-type';
import { menuTransfer, getMenuFlat, generatePathMap } from './app-child/menuTool';

import AppMenu from './app-child/AppMenu.vue';
import AppNav from './app-child/AppNav.vue';
import CustomRouter from './router/custom-router.vue';

export default {
  setup() {
    // 基本信息
    const {
      api, store, lib, popup,
    } = inject('global');
    const app = inject('app');
    const startFlag = ref('loading');
    const $confirm = inject('$confirm');
    const message = inject('$message');
    const router = useRouter();
    const route = useRoute();

    const companyInfo = reactive({});

    const loginData = inject('businessLoginData');
    const { on } = inject('useEvent')();
    // eslint-disable-next-line no-use-before-define
    getMenu()
      .then((menuCodeList) => {
        // 设置权限
        const permission = loginData.teacherPermissionDto?.permissions || [];
        const isSuperAdmin = loginData.userInfo.superAdmin;
        lib.setPermission(permission, isSuperAdmin, loginData.userInfo.admin);
        store.commit('user', loginData.userInfo);
        store.commit('globalCampusList', loginData.userInfo?.campusList || []);

        // 过期.
        const companyProduct = loginData.userInfo?.companyInfoVo?.companyProduct;
        if (companyProduct?.expired && companyProduct?.productStatus > 0) {
          startFlag.value = 'server-expired';
          companyInfo.companyName = loginData.userInfo.companyInfoVo.companyName;
          companyInfo.productStatus = companyProduct.productStatus;
          companyInfo.companyList = store.companyList;
        }

        // 处理无权限的菜单页面
        router.beforeEach((to) => {
          if (to.meta.menuCode !== 'pcHome' && to.meta.menuCode && !menuCodeList.includes(to.meta.menuCode)) {
            setTimeout(() => {
              message.warning('没有权限访问目标页面，已为你跳转至首页');
            }, 0);
            return '/home';
          }
          return true;
        });
        // 添加Google分析start
        // 路由页面统计
        router.afterEach((to) => {
          if (to.meta.menuName) {
            setTimeout(() => {
              // eslint-disable-next-line no-undef
              gtag('event', 'x3-pc-event-page', {
                x3_web_env: process.env.VUE_APP_x3_env,
                x3_pc_bunisess_type: 'x3-PC-老师端',
                x3_client_type: app.tool.getBrowserType(),
                x3_company_name: store.user.value.companyInfoVo.companyName,
                x3_nav_menu_name: to.meta.menuName,
                x3_page_alias: `${document.title}-${to.meta.menuName}`,
                x3_page_path: to.path,
              });
            }, 301);
          }
        });
        // 添加Google分析end

        if (route.meta?.menuCode !== 'pcHome' && route.meta?.menuCode && !menuCodeList.includes(route.meta?.menuCode)) {
          setTimeout(() => {
            message.warning('没有权限访问目标页面，已为你跳转至首页');
          }, 0);
          return router.replace('/home');
        }
        // 密码提示
        if (!loginData.userInfo.hasPassword) {
          $confirm('账号未设置密码，无法使用密码登录。是否设置登录密码？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info',
          }).then(() => {
            router.push('/my-info');
          });
        }
        return true;
      })
      .finally(() => {
        if (startFlag.value === 'loading') {
          startFlag.value = 'ready';
        }
      });

    // 切换主题
    function handleCommand(command) {
      app.css.themeChange(command, true);
    }

    // menu和面包屑
    const list = ref([]);
    const breadList = ref([]);
    const pathMap = generatePathMap();
    async function getMenu() {
      const result = await api.myList();
      let menuCodeList = [];
      result.data.unshift({
        menuCode: 'pcHome',
        menuName: '首页',
        childMenuVos: [],
      });
      [list.value, menuCodeList] = menuTransfer(result.data, pathMap);
      // list.value.unshift({
      //   childMenuVos: [],
      //   icon: '#icon-huiyuanjifen',
      //   menuCode: 'pcHome',
      //   menuId: -1000,
      //   menuName: '首页',
      //   path: '/home',
      // });
      watch(
        () => route.path,
        async (path) => {
          breadList.value = getMenuFlat(path);
        },
        {
          immediate: true,
        },
      );
      return menuCodeList;
    }
    const collapse = ref(false);

    on(events.appNavListRefresh, getMenu);

    return {
      startFlag,
      list,
      LogoTitle,
      qrcode,
      breadList,
      companyInfo,
      handleCommand,
      pageScroll({ scrollLeft, scrollTop }) {
        updatePosition(scrollLeft, scrollTop);
      },
      logout() {
        lib.logout();
      },
      changeCompany() {
        popup('company-change');
      },
      collapse,
      onCollapse(val) {
        collapse.value = val;
      },
    };
  },
  components: {
    AppMenu,
    AppNav,
    CustomRouter,
  },
};
</script>

<style lang="scss">
// 弹框按钮颜色重置
.aiGrowthConfirmButtonClass {
  background-color: #2284FE !important;
}
#app {
  height: 100%;
  // background: var(--g9);
  background: #eff3fb;

  #yunxiao {
    width: 100%;
    height: 100%;
    display: flex;
    overflow: hidden;

    .right-panel {
      flex: 1 1 auto;
      overflow: hidden;
      position: relative;

      .nav-container {
        height: 54px;
      }

      .right-area {
        height: calc(100% - 50px);
        padding-left: 8px;
        padding-top: 12px;

        .page-container {
          height: 100%;
          padding-right: 16px;

          .bread-crumb {
            height: 20px;
            line-height: 20px;
            // background: var(--g9);
            font-weight: 400;
            font-size: var(--fs-md);
            // margin-top: 16px;
            margin-bottom: 8px;
          }

          .page {
            // margin-top: 12px;
            min-height: calc(100vh - 132px);
          }
        }
      }
    }
  }

  .server-expired {
    background: var(--g9);
    position: absolute;
    min-height: 500px;
    width: 100%;
    height: 100%;
    left: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .logo-container {
      position: absolute;
      top: 10px;
      left: 30px;
      z-index: 1;
      height: 40px;
      cursor: pointer;
    }

    .center-info {
      text-align: center;

      .company-name {
        font-size: 24px;
        line-height: 28px;
        margin-bottom: 22px;
        color: var(--g1);
        font-weight: 600;
      }

      .desc {
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        color: var(--g2);
        font-weight: 400;
        margin-bottom: 13px;
      }

      .btn {
        margin-right: 24px;
      }

      .qr-code {
        width: 148px;
        height: 148px;
        margin: 21px auto 32px;
      }
    }

    .about {
      position: absolute;
      bottom: 20px;
      width: 100%;
      left: 0;
      display: flex;
      align-items: center;
      flex-direction: column;

      .about-1 {
        font-size: 14px;
        color: var(--g2);
        line-height: 14px;
        margin-bottom: 15px;
      }

      .about-2 {
        font-size: 12px;
        color: var(--g3);
        line-height: 12px;
      }
    }
  }
}
</style>
